import React from "react";
import { IconExternalLinkTrans } from "../Icons";

export default function ExternalLink({children, to, noIcon, iconBold, ...rest}) {
    return <a href={to} target="_blank" rel="nofollow noopener noreferrer" {...rest}>
        {children}{!noIcon && <sup className="icon"><IconExternalLinkTrans size={1.1} bold={iconBold}/></sup>}
    </a>
}